<template>
    <v-container fluid class="pt-0">
        <v-row align="center" justify="center">
            <v-col cols="12" class="pa-0">
                <v-sheet class="" color="#008dd4" height="10vh"></v-sheet>
            </v-col>

            <v-col cols="12" lg="7" md="10" sm="12" xs="12" style="margin-top: -5vh">
                <v-alert border="top" color="red lighten-2" dark class="elevation-2 text-center mt-3">
                    <strong>Los horarios están registrados utilizando la zona horaria estándar del centro (GMT-6)</strong>
                </v-alert>

                <v-stepper v-model="stepper">
                    <v-stepper-header>
                        <v-stepper-step step="1">Inicio</v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step step="2">Idioma</v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step step="3">Cursos</v-stepper-step>
                    </v-stepper-header>

                    <v-stepper-items>
                        <v-stepper-content step="1">
                            <v-card>
                                <v-card-title style="display: block !important" class="text-center">Inscribete al curso que se adapte mejor a ti.</v-card-title>
                                <v-card-text class="py-0">
                                    <p class="text-center">En Instituto Neumann nos importa tu tiempo, por eso puedes seleccionar el curso que más se adapte a ti y a tus necesidades.</p>
                                </v-card-text>
                                <v-divider></v-divider>
                                <v-card-actions>
                                    <v-btn block color="#008dd4" @click="stepper = 2" dark>¡Comencemos!</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-stepper-content>

                        <v-stepper-content step="2">
                            <v-card>
                                <v-card-title>Selecciona el idioma</v-card-title>
                                <v-card-text>
                                    <v-list>
                                        <v-list-item-group mandatory v-model="language_id" active-class="blue--text text--darken-4">
                                            <template v-for="language in languages">
                                                <v-list-item :key="language.id" :value="language.id" @click="stepper = 3">
                                                    <template v-slot:default="{ active }">
                                                        <v-list-item-avatar size="60">
                                                            <v-img :src="language_image_url+language.image"></v-img>
                                                        </v-list-item-avatar>
                                                        <v-list-item-content>
                                                            <v-list-item-title>{{ language.language }}</v-list-item-title>
                                                        </v-list-item-content>
                                                    </template>
                                                </v-list-item>
                                            </template>
                                        </v-list-item-group>
                                    </v-list>
                                </v-card-text>
                            </v-card>
                        </v-stepper-content>

                        <v-stepper-content step="3">
                            <v-card>
                                <v-card-title>Selecciona tu curso</v-card-title>    
                                <v-card-text>
                                    <v-skeleton-loader type="card" :hidden="!skeleton_loading"></v-skeleton-loader>
                                    <template v-if="courses.length > 0">
                                        <v-card v-for="(course, index) in order_courses" :key="index" class="mb-3" outlined>
                                            <v-card-text class="py-0 px-0">
                                                <v-container class="py-0 px-0" fluid>
                                                    <v-row no-gutters>
                                                        <v-col cols="12" lg="2" md="2" sm="12" xs="12" class="text-center align-center" style="background-color: #008dd4">
                                                            <v-container fill-height class="px-0">
                                                                <v-row>
                                                                    <v-col>
                                                                        <h3 class="py-2 white--text">Inicio : {{ course.schedule[0].start_time }}</h3>
                                                                        <v-divider dark></v-divider>
                                                                        <h3 class="py-2 white--text">Fin : {{ course.schedule[0].end_time }}</h3>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-container>
                                                        </v-col>
                                                        
                                                        <v-col class="px-2 py-2" cols="12" lg="9" md="9" sm="12" xs="12">
                                                            <v-list-item-title>{{ course.name }}</v-list-item-title>
                                                            <v-list-item-subtitle class="mt-4">Nivel : <strong>{{ course.level.name }}</strong></v-list-item-subtitle>
                                                            <v-list-item-subtitle class="mt-4">Lugares disponibles : <strong>{{ course.spaces }}</strong> </v-list-item-subtitle>
                                                            <v-list-item-subtitle class="mt-4" v-if="course.modality.id === 1">Días : <strong>Lunes, Miércoles y Viernes</strong> </v-list-item-subtitle>
                                                            <v-list-item-subtitle class="mt-4" v-if="course.modality.id === 2">Días : <strong>Martes y Jueves</strong> </v-list-item-subtitle>
                                                            <v-list-item-subtitle class="mt-4" v-if="course.modality.id === 3">Días : <strong>Sábados</strong> </v-list-item-subtitle>
                                                            <v-list-item-subtitle class="mt-4" v-if="course.modality.id >= 4">Días : <strong>Lunes a viernes</strong> </v-list-item-subtitle>
                                                            <v-list-item-subtitle class="mt-4"><strong>Hora estándar del centro (GMT-6)</strong> </v-list-item-subtitle>
                                                            <v-list-item-subtitle class="mt-4">Fecha tentativa de inicio : <strong>{{ course.date }}</strong> </v-list-item-subtitle>
                                                        </v-col>
                                                    </v-row>
                                                </v-container>
                                            </v-card-text>
                                            <v-divider></v-divider>
                                            <v-card-actions class="py-0 px-0">
                                                <v-btn block text tile @click="() => {selected_course = course; dialog = true}">Seleccionar curso</v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </template>
                                    <v-card v-else outlined>
                                        <v-list>
                                            <v-list-item>
                                                <v-list-item-icon>
                                                    <v-icon x-large style="font-size: 4rem">mdi-emoticon-sad-outline</v-icon>
                                                </v-list-item-icon>
                                                <v-list-item-content>
                                                    <v-list-item-title>Sin cursos disponibles</v-list-item-title>
                                                    <v-list-item-subtitle>Lamentablemente no tenemos cursos disponibles.</v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                    </v-card>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn text color="#000" @click="() => { stepper = 2; skeleton_loading = true }">Atrás</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>

                
            </v-col>
        </v-row>

        <v-dialog v-model="dialog" scrollable width="900" persistent>
            <v-card>
                <v-card-title><h3>Resumen de preinscripción</h3></v-card-title>
                <v-card-text>
					<v-subheader><strong>Curso seleccionado</strong></v-subheader>
                    <v-row no-gutters>
                        <v-col cols="12" class="elevation-2 pa-5 mb-4">
                            <h3 class="mb-2"><strong>Nombre del curso : </strong>{{ selected_course.name }}</h3>
                            <template v-for="(level, index) in selected_course.level">
                            	<h3 class="mb-2" :key="index" v-if="index == 'name'"> <strong>Nivel :</strong> {{ level }} </h3>
                            </template>
							<template v-for="(modality, index) in selected_course.modality">
                            	<h3 class="mb-2" :key="index" v-if="index == 'name'"> <strong>Modalidad :</strong> {{ modality }} </h3>
                            </template>
							<v-simple-table>
								<template v-slot:default>
									<thead>
										<tr>
											<th>Día</th>
											<th>Hora de inicio</th>
											<th>Hora de termino</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(schedule, index) in selected_course.schedule" :key="index">
											<td v-text="schedule.day"></td>
											<td v-text="schedule.start_time+' (GMT-6)'"></td>
											<td v-text="schedule.end_time+' (GMT-6)'"></td>
										</tr>
									</tbody>
								</template>
							</v-simple-table>
                        </v-col>

						<v-subheader><strong>Balance</strong></v-subheader>

						<v-col cols="12" class="elevation-2 pa-5 mb-4">
							<v-simple-table flat>
								<template v-slot:default>
									<tbody>
										<tr>
											<td class="text-right">Inscripción y mensualidad</td>
											<td class="text-right">${{ selected_course.inscription_price + selected_course.monthly_payment }}</td>
										</tr>
										<tr>
											<td class="text-right">Mi balance</td>
											<td class="text-right">${{ balance.balance }}</td>
										</tr>
										<tr>
											<td class="text-right">Total</td>
											<td class="text-right"><strong> ${{ (selected_course.inscription_price + selected_course.monthly_payment) - balance.balance }}</strong></td>
										</tr>
									</tbody>
								</template>
							</v-simple-table>
						</v-col>

                        <v-col cols="12" v-if="500 - balance.balance > 0">
                            <v-alert class="text-center" color="red lighten-2" dark>
                                <strong>
                                    Recuerda que para conservar tu lugar debes realizar el pago correspondiente antes de 24 horas.
                                </strong>
                            </v-alert>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialog = false" :disabled="loading">CANCELAR</v-btn>
                    <v-btn color="#008dd4" dark :loading="loading" @click="submit"><strong>confirmar registro</strong> </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="success_dialog" width="600" persistent>
            <v-card>
                <v-card-title class="headline green lighten-2 white--text"><strong>Registro correcto</strong></v-card-title>
                <v-card-text class="pa-5">
                    <h3 class="text-center mb-5">Te has registrado correctamente al curso, recuerda realizar los pagos correspondientes antes de 24 horas para conservar tu lugar.</h3>
                    <v-simple-table flat>
                        <template v-slot:default>
                            <tbody>
                                <tr>
                                    <td>CLABE</td>
                                    <td><strong>012 180 00469235582 8</strong></td>
                                </tr>
                                <tr>
                                    <td>Número de tarjeta</td>
                                    <td><strong>4152 3138 7681 3309</strong></td>
                                </tr>
                                <tr>
                                    <td>Banco</td>
                                    <td><strong>BBVA Bancomer</strong></td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-card-text>
                <v-card-actions>
                    <v-btn class="mx-auto" @click="redirect" block text><strong>Aceptar</strong></v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>
<script>

import iziToast from 'izitoast'
const meses = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre']

export default {
    props:['levels', 'balance', 'current_course','languages','current_courses'],
    data: () => ({
        courses_url:"/my-courses/select-course",
        post_url:"/my-courses/select-course",
        language_image_url:"/storage/langs_disk/",
        initial_avatar:"https://ui-avatars.com/api/?name=",
        final_avatar:"&background=random",
        courses: [],
        stepper:1,
        modality_id:"",
        level_id:"",
        selected_course:"",
        button:false,
        dialog:false,
        proof:false,
        loading:false,
        skeleton_loading:true,
        success_dialog: false,
        modalities:[
            { modality_id: 1, text: 'Lunes, Miércoles y Viernes' },
            { modality_id: 2, text: 'Martes y Jueves' },
            { modality_id: 3, text: 'Sábados' }
        ],


        //new_design
        language_id:"",
        age:3,
    }),

    watch:{
        stepper:function(val){
            val === 3 ? this.getCourses() : ''
        }
    },

    mounted(){
        
        this.current_courses.forEach(course => {
            this.languages.forEach((language, index) => {
                console.log("prueba")
                console.log(language)
                console.log(course)
                if(language.id == course.course.language_id)
                {
                    this.languages.splice(index,1);
                    console.log(this.languages)
                }
                    
            });
        });
       // if(this.current_course) location.replace('/home');
    },

    computed:{
        order_courses:function(){
            let order_courses = []
            for(let course of this.courses){
                course.date = course.start_date.split('-').reverse()
                course.date[1] = meses[parseInt(course.date[1])-1]
                course.date = course.date.join('/')
                course.spaces = course.student_limit - course.number_students <= course.rm_students ? course.student_limit - course.number_students : course.rm_students
                order_courses.push(course)
            }

            return order_courses
        },
    },

    methods:{
        getCourses: function(){
            let data = {}
            let modalities = []
            data.language_id = this.language_id

            if(this.age == 1) modalities.push(4);
            if(this.age == 2) modalities.push(5);

            if(this.age > 2){
                modalities = []
                modalities.push(1,2,3)
            }

            data.modalities = modalities

            axios.get(this.courses_url, { params: data }).then(response => {
                this.courses = response.data.courses
                this.skeleton_loading = false

            }).catch(error => { console.log(error) });
        },

        submit:function(){
            this.loading = true
            let data = {}
            data.course_id = this.selected_course.id
            axios.post(this.post_url, data).then(response => {
                this.loading = false
                this.dialog = false
                this.success_dialog = true
            }).catch(error => {
                this.dialog = this.loading = false
                iziToast.error({
                    title:"Error",
                    message:"El curso seleccionado ya no tiene lugares disponibles",
                    position:"topRight"
                }) 
            })
        },

        redirect: function(){
            location.replace('/home');
        }
    }
}
</script>
